import React, { useEffect, useState } from 'react';
import ProductModel from './models/ProductModel';
import ProductDetailsFields from './ProductDetailsFields';

function AddProduct({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState(new ProductModel());
  const [slugManual, setSlugManual] = useState(false);

  useEffect(() => {
    const initial = new ProductModel();
    if (onLoad) onLoad(initial);
    if (sendDataToParent) sendDataToParent(initial);
  }, []);

  const handleData = (data) => {
    setFormData(data);
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <ProductDetailsFields
        formData={formData}
        sendDataToParent={handleData}
        slugManual={slugManual}
        onSlugManualChange={setSlugManual}
      />
    </div>
  );
}

export default AddProduct;
